import { SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

import { StakeNotDividablePreCheckBaseError } from '../../errors/pre-check/stake-not-dividable-pre-check-base-error';

export abstract class StakeNotDividableValidator<TError extends StakeNotDividablePreCheckBaseError> {
    protected constructor(
        private userService: UserService,
        private userSettings: SyncUserSettingsService,
    ) {}

    protected abstract createError(exampleStakes: Decimal[], divident: Decimal): TError;

    protected *validateInternal(betStake: number | null): Iterable<StakeNotDividablePreCheckBaseError> {
        yield* this.validateDividable(
            new Decimal(this.userSettings.configSettings.minimumStakeUnit || 0),
            new Decimal(betStake || 0).toDecimalPlaces(2),
        );
        yield* this.validateDividable(new Decimal(this.userService.columnSize || 0), new Decimal(betStake || 0));
    }

    private *validateDividable(divident: Decimal, betStake: Decimal): Iterable<TError> {
        if (divident.greaterThan(0) && betStake.greaterThan(0)) {
            const rest = this.getDivisionReminder(betStake, divident);
            if (rest.equals(0)) {
                return;
            }
            const exampleStakes = this.generateStake(betStake, divident, 3);
            yield this.createError(exampleStakes, divident);
        }
    }

    private getDivisionReminder(divider: Decimal, dividend: Decimal): Decimal {
        return divider.times(100).modulo(dividend.times(100));
    }

    private generateStake(stake: Decimal, columnSize: Decimal, count: number): Decimal[] {
        const arr: Decimal[] = Array(count);
        let start = stake.minus(stake.modulo(columnSize)) || columnSize;
        if (start.isZero()) {
            start = columnSize;
        }
        for (let i = 0; i < count; i++) {
            arr[i] = i === 0 ? start : arr[i - 1].plus(columnSize);
        }

        return arr;
    }
}
